import rajpur_samadhi from "../images/rajpur_samadhi_logo.jpg";
import google_maps_logo from "../images/maps_logo.png";
import youtube_link from "../images/youtube-logo.png";
import "../styles/App.css";

const Footer = () => {
  const googleMapsLink = "https://maps.app.goo.gl/jWWm7KBSwyzbREV59";
  const youTubeLink = "https://www.youtube.com/@brahmvidyalayandashram4699";
  return (
    <div className="footer">
      <div className="footer-left">
        <h3>मुख्य स्थान :</h3>
        <div>ब्रह्म विद्यालय एवं आश्रम,</div>
        <div>छोटका राजपुर, बक्सर</div>
        <div>बिहार</div>
        <div className="footer-map-link">
          <a
            href={googleMapsLink}
            target="_blank"
            rel="noopener noreferrer"
            className="map-link"
          >
            View on Google Maps
          </a>
          <img
            src={google_maps_logo}
            alt="Google map icon"
            width="30px"
            height="30px"
          />
        </div>
       
      </div>

      <div className="footer-logo">
        <img
          src={rajpur_samadhi}
          alt="Brahm Vidyalaya and Ashram samadhi mandir logo"
        />
        
      </div>

      <div className="footer-right">
        <h3>अधिक जानकारी :</h3>
        <div>Email : brahmavidyalayaandashram@gmail.com</div>
        <div>Phone : +91-80106 76467</div>
         <div className="footer-youtube-link">
          <a
            href={youTubeLink}
            target="_blank"
            rel="noopener noreferrer"
            className="youtube-link"
          >
            Watch on Youtube
          </a>
          <img
            src={youtube_link}
            alt="Youtube link icon"
            width="30px"
            height="30px"
          />
        </div>
      </div>
    </div>
  );
};
export default Footer;
